// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-in-enter-active[data-v-cbb65f10],.fade-in-leave-active[data-v-cbb65f10]{transition:opacity .3s}.fade-in-enter[data-v-cbb65f10],.fade-in-leave-to[data-v-cbb65f10]{opacity:0}.slide-up-enter-active[data-v-cbb65f10],.slide-up-leave-active[data-v-cbb65f10]{transition:transform .3s}.slide-up-enter[data-v-cbb65f10],.slide-up-leave-to[data-v-cbb65f10]{transform:translateY(20px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
